// ==============================================
// CUSTOM CODE: Auto-expand "Shop" in mobile menu drawer
// Purpose: Opens the Shop submenu automatically when the mobile menu is opened.
// Customers no longer need to tap "Shop" inside the drawer.
// This only affects the mobile navigation drawer.
// Desktop mega menu / hover behavior remains unchanged.
// Safe to keep — will not be overwritten on theme updates.
// ==============================================

(function () {
  function autoExpandShopMenu() {
    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    const menuContainer = headerDrawer.querySelector('details.menu-drawer-container');
    if (!menuContainer) return;

    function expandShop() {
      // Only act when the main drawer is actually open
      if (!menuContainer.hasAttribute('open')) return;

      // Find any submenu <details> that contains a link with "Shop" in the text.
      // This covers the main menu and any secondary menu lists in the drawer.
      const allSubDetails = menuContainer.querySelectorAll('details');

      allSubDetails.forEach((detailsEl) => {
        // Find the link text inside the summary
        const link = detailsEl.querySelector(
          'summary a.menu-drawer__menu-link, summary a'
        );
        if (!link) return;

        const linkText = (link.textContent || '').trim().toLowerCase();

        // Match "Shop" (or localized variants containing "shop")
        if (linkText.includes('shop')) {
          // Force the native details open
          detailsEl.setAttribute('open', '');

          // Add the class the theme uses for caret rotation + styling
          detailsEl.classList.add('menu-opening');
        }
      });
    }

    // Watch the main drawer container for the 'open' attribute
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'open'
        ) {
          // Small delay lets the drawer finish its open animation
          setTimeout(expandShop, 40);
        }
      }
    });

    observer.observe(menuContainer, {
      attributes: true,
      attributeFilter: ['open'],
    });

    // Run once shortly after load (in case drawer is open on init)
    setTimeout(expandShop, 120);

    // Extra safety: run shortly after clicking the hamburger icon
    const menuSummary = headerDrawer.querySelector(
      'summary.header__icon--menu, summary.header__icon--summary'
    );
    if (menuSummary) {
      menuSummary.addEventListener('click', () => {
        // The click opens it, so wait a bit
        setTimeout(expandShop, 60);
      });
    }
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoExpandShopMenu);
  } else {
    autoExpandShopMenu();
  }

  // Re-run when Shopify theme editor reloads sections
  document.addEventListener('shopify:section:load', autoExpandShopMenu);
})();